import axios from 'axios';
import { toast } from 'react-toastify';
import { jwtDecode } from "jwt-decode";



const api = axios.create({
    baseURL: '/api',
    timeout: 30000,
});

// Add a request interceptor
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            const decoded = jwtDecode(token);
            if (!decoded.isActive) {
                localStorage.clear();
                window.location.reload();
                return Promise.reject(new Error('Inactive user'));
            }
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        Promise.reject(error);
    }

);
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (!error.response) {
            toast.error(error.code === 'ECONNABORTED' ? 'Request timed out' : 'Network error');
            return Promise.reject(error);
        }
        // Remove token and redirect
        if (error.response.status === 401) {
            toast.error('not Authorized');
            localStorage.clear()
            window.location.reload();
        }

        if (error.response.status === 404) {
            toast.error('Not Found');
        }

        if (error.response.status === 500) {
            toast.error('Internal Server Error');
        }

        if (error.response.status === 508) {
            toast.error('Time Out');
        }

        return Promise.reject(error);
    }
);


export default api
